import { atom, type Atom } from "nanostores"

type EventPayload = unknown

const topicMap = new Map<string, Atom<EventPayload | null>>()

export function getTopic<T = unknown>(name: string): Atom<T | null> {
  if (!topicMap.has(name)) {
    topicMap.set(name, atom<T | null>(null))
  }
  return topicMap.get(name)! as Atom<T | null>
}

export function emitTopicEvent<T = unknown>(name: string, payload: T) {
  const topic = getTopic<T>(name)
  ;(topic as any).set(payload)
  queueMicrotask(() => (topic as any).set(null))
}
